var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { AddressService } from 'app/services/address.service';
import { transform } from 'ol/proj';
var FeatAddressSearchComponent = /** @class */ (function () {
    function FeatAddressSearchComponent(elemRef, addressService) {
        this.elemRef = elemRef;
        this.addressService = addressService;
        this.addressStr = '';
        this.showAddressList = false;
        this.addressList = [];
        this.isSearchFocused = false;
        this.selectAddress = new EventEmitter();
    }
    FeatAddressSearchComponent.prototype.onDocumentClick = function (e) {
        if (e.target && !this.elemRef.nativeElement.contains(e.target)) {
            this.toggleAddressList(false);
        }
    };
    FeatAddressSearchComponent.prototype.searchAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addressStr, latlong, trimedString, coord, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        addressStr = this.addressStr;
                        if (typeof (addressStr) === 'string') {
                            trimedString = addressStr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/\s\s+/g, ' ');
                            latlong = this.addressService.isLatLongDecimal(trimedString);
                            if (!latlong) {
                                latlong = this.addressService.isLatLongDMS(trimedString);
                            }
                        }
                        if (!latlong) return [3 /*break*/, 1];
                        coord = transform(latlong, 'EPSG:4326', 'EPSG:3857');
                        this.addressList = [{
                                addr: latlong,
                                coord: coord
                            }];
                        return [3 /*break*/, 3];
                    case 1:
                        // this.addressList = [];// TODO
                        _a = this;
                        return [4 /*yield*/, this.addressService.searchAddressByGoogle(addressStr)];
                    case 2:
                        // this.addressList = [];// TODO
                        _a.addressList = _b.sent();
                        _b.label = 3;
                    case 3:
                        // this.addressList = this.addressList.concat([{
                        // 	addr: 'test1'
                        // }, {
                        // 	addr: 'test2'
                        // }])
                        // If only one result is returned, pick that result
                        if (this.addressList.length === 1) {
                            this.selectAddress.emit(this.addressList[0]);
                        }
                        else {
                            this.toggleAddressList(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatAddressSearchComponent.prototype.selectAddressFromList = function (address) {
        this.toggleAddressList(false);
        this.selectAddress.emit(address);
    };
    FeatAddressSearchComponent.prototype.toggleAddressList = function (isShow) {
        this.showAddressList = isShow;
    };
    FeatAddressSearchComponent.prototype.ngOnInit = function () {
    };
    return FeatAddressSearchComponent;
}());
export { FeatAddressSearchComponent };
